import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '../../components/wui-icon/index.js';
import '../../components/wui-image/index.js';
import { resetStyles } from '../../utils/ThemeUtil.js';
import { customElement } from '../../utils/WebComponentsUtil.js';
import '../wui-icon-box/index.js';
import styles from './styles.js';
let WuiWalletImage = class WuiWalletImage extends LitElement {
  constructor() {
    super(...arguments);
    this.size = 'md';
    this.name = '';
    this.installed = false;
    this.badgeSize = 'xs';
  }
  render() {
    let borderRadius = 'xxs';
    if (this.size === 'lg') {
      borderRadius = 'm';
    } else if (this.size === 'md') {
      borderRadius = 'xs';
    } else {
      borderRadius = 'xxs';
    }
    this.style.cssText = "\n       --local-border-radius: var(--wui-border-radius-".concat(borderRadius, ");\n       --local-size: var(--wui-wallet-image-size-").concat(this.size, ");\n   ");
    if (this.walletIcon) {
      this.dataset['walletIcon'] = this.walletIcon;
    }
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <wui-flex justifyContent=\"center\" alignItems=\"center\"> ", " </wui-flex>\n    "])), this.templateVisual());
  }
  templateVisual() {
    if (this.imageSrc) {
      return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<wui-image src=", " alt=", "></wui-image>"])), this.imageSrc, this.name);
    } else if (this.walletIcon) {
      return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<wui-icon\n        data-parent-size=\"md\"\n        size=\"md\"\n        color=\"inherit\"\n        name=", "\n      ></wui-icon>"])), this.walletIcon);
    }
    return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<wui-icon\n      data-parent-size=", "\n      size=\"inherit\"\n      color=\"inherit\"\n      name=\"walletPlaceholder\"\n    ></wui-icon>"])), this.size);
  }
};
WuiWalletImage.styles = [resetStyles, styles];
__decorate([property()], WuiWalletImage.prototype, "size", void 0);
__decorate([property()], WuiWalletImage.prototype, "name", void 0);
__decorate([property()], WuiWalletImage.prototype, "imageSrc", void 0);
__decorate([property()], WuiWalletImage.prototype, "walletIcon", void 0);
__decorate([property({
  type: Boolean
})], WuiWalletImage.prototype, "installed", void 0);
__decorate([property()], WuiWalletImage.prototype, "badgeSize", void 0);
WuiWalletImage = __decorate([customElement('wui-wallet-image')], WuiWalletImage);
export { WuiWalletImage };
//# sourceMappingURL=index.js.map